import React, { useContext } from "react";
import { Icon } from "components/SvgIcons";
import GroceryContext from "./GroceryContext";
import { IngredientItemContainer, CheckWrap, ItemText, ItemName, ItemDescription } from "./styled";

const IngredientItem = ({ item }) => {
  const { toggleItem } = useContext(GroceryContext);
  const { name, notes } = item;

  return (
    <IngredientItemContainer onClick={() => toggleItem(item)}>
      <CheckWrap>
        <Icon icon="check" />
      </CheckWrap>
      <ItemText>
        <ItemName>{name}</ItemName>
        <ItemDescription>{notes}</ItemDescription>
      </ItemText>
    </IngredientItemContainer>
  );
};

export default IngredientItem;
